"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSelect = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="v-select ${x => x.isOpen ? 'open' : ''} ${x => x.allowCreation ? 'with-creation' : ''} ${x => x.side === 'top' ? 'dropdown-top' : 'dropdown-bottom'}">
    <div class="v-select-input-container">
        <input 
            ${(0, fast_element_1.ref)('inputElement')}
            type="text"
            class="v-select-input"
            placeholder="${x => x.placeholder}"
            :value="${x => x.searchText}"
            @click="${(x, c) => { c.event.stopPropagation(); x.onInputClick(); }}"
            @input="${(x, c) => x.onInputChange(c.event)}"
            @keydown="${(x, c) => x.onInputKeyDown(c.event)}"
            @focus="${x => x.onInputClick()}"
            autocomplete="off"
        />
        ${(0, fast_element_1.when)(x => x.searchText && x.searchText.trim() && x.value && x.value !== 'null' && x.value !== '', (0, fast_element_1.html) `
            <button 
                type="button" 
                class="v-select-clear-btn" 
                @click="${(x, c) => { c.event.stopPropagation(); x.onClearClick(); }}"
                title="${'v-select.clear'.t()}"
            >
                <i class="simple-icon-close"></i>
            </button>
        `)}
        <div class="v-select-arrow ${x => x.isOpen ? 'open' : ''}" @click="${x => x.onInputClick()}">
            <i class="simple-icon-arrow-down"></i>
        </div>
        ${(0, fast_element_1.when)(x => x.allowCreation && x.searchText.trim() && !x.choiceList.find(c => c.label.toLowerCase() === x.searchText.toLowerCase()), (0, fast_element_1.html) `
            <button 
                type="button" 
                class="v-select-add-btn" 
                @click="${x => x.onAddButtonClick()}"
            >
                <i class="simple-icon-plus"></i>
            </button>
        `)}
    </div>
    
    ${(0, fast_element_1.when)(x => x.isOpen, (0, fast_element_1.html) `
        <div class="v-select-dropdown ${x => x.side === 'top' ? 'dropdown-top' : 'dropdown-bottom'}" ${(0, fast_element_1.ref)('dropdownElement')} @click="${(x, c) => c.event.stopPropagation()}">
            ${(0, fast_element_1.when)(x => x.filteredChoices.length === 0 && x.allowCreation && x.searchText.trim(), (0, fast_element_1.html) `
                <div class="v-select-option create-option" @click="${x => x.addNewItem()}">
                    <i class="simple-icon-plus"></i>
                    ${'v-select.createNew'.t()}: "${x => x.searchText}"
                </div>
            `)}
            ${(0, fast_element_1.when)(x => x.filteredChoices.length === 0 && (!x.allowCreation || !x.searchText.trim()), (0, fast_element_1.html) `
                <div class="v-select-no-options">${'v-select.noOptions'.t()}</div>
            `)}
            ${(0, fast_element_1.repeat)(x => x.filteredChoices, (0, fast_element_1.html) `
                <div 
                    class="v-select-option ${(x, c) => c.parent.isSelected(x) ? 'selected' : ''} ${(x, c) => c.parent.isHighlighted(x) ? 'highlighted' : ''}"
                    @click="${(x, c) => c.parent.selectOption(x)}"
                >
                    ${x => x.label}
                    ${(0, fast_element_1.when)(x => x.actions && x.actions.length > 0, (0, fast_element_1.html) `
                        <div class="v-select-option-actions">
                            ${(0, fast_element_1.repeat)(x => x.actions, (0, fast_element_1.html) `
                                <rws-tooltip text="${x => x.tooltip || ''}" disabled="${x => x.tooltip ? 'false' : 'true'}"><button 
                                    type="button" 
                                    class="v-select-action-btn"                                     
                                    @click="${(x, c) => { c.event.stopPropagation(); x.callback(); }}"
                                >
                                    <i class="simple-icon-${x => x.icon}"></i>
                                </button></rws-tooltip>
                            `)}
                        </div>
                    `)}
            `)}
        </div>
    `)}
</div> `;
require("./styles/layout.scss");
const styles = T.css `.v-select {
  position: relative;
  width: 100%;
  font-family: inherit;
}

.v-select-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.v-select-input {
  width: 100%;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  padding-right: 40px;
  font-size: 14px;
  height: 38px;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.v-select-input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(115, 35, 107, 0.2);
}
.v-select-input::placeholder {
  color: var(--text_color);
  opacity: 0.6;
}

.v-select-arrow {
  position: absolute;
  right: 12px;
  color: var(--text_color);
  opacity: 0.6;
  transition: transform 0.2s;
  cursor: pointer;
}
.v-select-arrow.open {
  transform: rotate(180deg);
}
.v-select-arrow i {
  font-size: 12px;
}

.v-select-clear-btn {
  position: absolute;
  right: 35px;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text_color);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  font-size: 10px;
  opacity: 0.6;
}
.v-select-clear-btn:hover {
  background: #f0f0f0;
  opacity: 1;
  color: var(--error_color);
}
.v-select-clear-btn i {
  font-size: 10px;
}

.v-select-input-container:has(.v-select-add-btn) .v-select-clear-btn {
  right: 60px;
}

.v-select-add-btn, .v-select-action-btn {
  position: absolute;
  right: 60px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
  font-size: 10px;
}
.v-select-add-btn:hover:not(:disabled), .v-select-action-btn:hover:not(:disabled) {
  background: var(--alt_blu);
}
.v-select-add-btn:disabled, .v-select-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.v-select-option-actions {
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-left: auto;
}
.v-select-option-actions .v-select-action-btn {
  display: inline-block;
  position: static;
}

.v-select-dropdown {
  position: absolute;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.v-select-dropdown.dropdown-bottom {
  top: 100%;
  border-top: none;
  border-radius: 0 0 4px 4px;
}
.v-select-dropdown.dropdown-top {
  bottom: 100%;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
}

.v-select-option {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
}
.v-select-option:hover {
  background: #f8f9fa;
}
.v-select-option.highlighted {
  background: var(--primary-color);
  color: white;
}
.v-select-option.selected {
  background: var(--primary-color);
  color: white;
}
.v-select-option.selected:hover, .v-select-option.selected.highlighted {
  background: var(--primary-color);
  opacity: 0.8;
}
.v-select-option.create-option {
  color: var(--primary-color);
  font-weight: 500;
  border-bottom: 1px solid #f8f9fa;
}
.v-select-option.create-option i {
  margin-right: 8px;
  font-size: 12px;
}
.v-select-option.create-option:hover {
  background: rgba(115, 35, 107, 0.1);
}

.v-select-no-options {
  padding: 12px;
  text-align: center;
  color: var(--text_color);
  opacity: 0.6;
  font-style: italic;
  font-size: 14px;
}

.v-select.open.dropdown-bottom .v-select-input {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: #ddd;
}
.v-select.open.dropdown-top .v-select-input {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top-color: #ddd;
}

.v-select-input:focus + .v-select-arrow {
  color: var(--primary-color);
  opacity: 1;
}

.v-select-dropdown::-webkit-scrollbar {
  width: 6px;
}
.v-select-dropdown::-webkit-scrollbar-track {
  background: #f8f9fa;
}
.v-select-dropdown::-webkit-scrollbar-thumb {
  background: var(--text_color);
  opacity: 0.3;
  border-radius: 3px;
}
.v-select-dropdown::-webkit-scrollbar-thumb:hover {
  background: var(--primary-color);
  opacity: 0.6;
}`;
const shadowOptions = { "mode": "open" };
let VSelect = class VSelect extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.choiceList = [];
        this.realValue = '';
        this.creationReady = true;
        this.isOpen = false;
        this.searchText = '';
        this.filteredChoices = [];
        this.highlightedIndex = -1;
        this.placeholder = 'Wybierz...';
        this.value = '';
        this.name = '';
        this.required = false;
        this.allowCreation = false;
        this.side = 'bottom';
        this.handleOutsideClick = (e) => {
            if (!this.isOpen)
                return; // Don't do anything if already closed
            const target = e.target;
            // Don't close if clicking inside THIS specific component or its dropdown
            if (this.contains(target) ||
                (this.dropdownElement && this.dropdownElement.contains(target))) {
                return;
            }
            this.isOpen = false;
            // DON'T change searchText when closing - keep whatever was typed
            this.highlightedIndex = -1;
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        this.filteredChoices = [...this.choiceList];
        this.updateRealValue();
        this.syncValueWithChoices();
        // Close dropdown when clicking outside - use arrow function to preserve 'this'
        document.addEventListener('click', this.handleOutsideClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('click', this.handleOutsideClick);
    }
    reset() {
        this.value = '';
        this.realValue = '';
        this.searchText = '';
        this.isOpen = false;
        this.highlightedIndex = -1;
        this.updateFilteredChoices();
    }
    choiceListChanged(old, newVal) {
        this.filteredChoices = [...(newVal || [])];
        this.updateRealValue();
        // Re-sync value in case it was set before choiceList was populated
        this.syncValueWithChoices();
    }
    valueChanged(old, newVal) {
        console.log({ newVal });
        this.updateRealValue();
        this.syncValueWithChoices();
    }
    syncValueWithChoices() {
        // Ensure the displayed text matches the selected value
        if (this.choiceList && this.choiceList.length > 0) {
            // Handle null/empty values - look for null value option
            if (!this.value || this.value === 'null' || this.value === '') {
                const nullOption = this.choiceList.find(e => e.value === null || e.value === 'null' || e.value === '');
                if (nullOption && !this.isOpen) {
                    this.searchText = nullOption.label;
                    this.realValue = nullOption.label;
                    return;
                }
            }
            // Handle regular values
            if (this.value) {
                const selected = this.choiceList.find(e => e.value === this.value);
                if (selected && !this.isOpen) {
                    this.searchText = selected.label;
                    this.realValue = selected.label;
                }
            }
        }
    }
    searchTextChanged() {
        this.updateFilteredChoices();
    }
    isOpenChanged() {
        if (this.isOpen) {
            // Highlight the currently selected option when opening
            this.setHighlightToCurrentSelection();
            // Focus input when opening
            setTimeout(() => {
                if (this.inputElement) {
                    this.inputElement.focus();
                }
            }, 0);
        }
    }
    updateRealValue() {
        if (this.choiceList) {
            // Handle null/empty values - look for null value option first
            if (!this.value || this.value === 'null' || this.value === '') {
                const nullOption = this.choiceList.find(e => e.value === null || e.value === 'null' || e.value === '');
                if (nullOption) {
                    console.log({ nullOption });
                    this.realValue = nullOption.label;
                    this.searchText = this.realValue;
                    return;
                }
                // If no null option and required, select first option
                if (this.required && this.choiceList.length > 0) {
                    this.realValue = this.choiceList[0].label;
                    this.searchText = this.realValue;
                    return;
                }
                // No value and not required
                this.realValue = '';
                this.searchText = '';
                return;
            }
            // Handle regular values
            if (this.value) {
                const selected = this.choiceList.find(e => e.value === this.value);
                this.realValue = (selected === null || selected === void 0 ? void 0 : selected.label) || '';
                this.searchText = this.realValue;
            }
        }
        else {
            this.realValue = '';
            this.searchText = '';
        }
    }
    updateFilteredChoices() {
        if (!this.searchText) {
            this.filteredChoices = [...this.choiceList];
        }
        else {
            this.filteredChoices = this.choiceList.filter(choice => choice.label.toLowerCase().includes(this.searchText.toLowerCase()));
        }
    }
    onInputClick() {
        var _a;
        if (!this.isOpen) {
            // Preserve the current input value
            const currentInputValue = ((_a = this.inputElement) === null || _a === void 0 ? void 0 : _a.value) || this.searchText;
            this.isOpen = true;
            // Show ALL entries when clicking - no filtering
            this.filteredChoices = [...this.choiceList];
            // Keep the current text in the input - DON'T change searchText here
            if (currentInputValue) {
                this.searchText = currentInputValue;
            }
            else {
                // Only set searchText if input is empty and we have a selected value
                if (this.value !== undefined && this.value !== null && this.value !== '') {
                    const selected = this.choiceList.find(e => e.value === this.value);
                    if (selected) {
                        this.searchText = selected.label;
                    }
                }
                else {
                    // Handle null/empty values
                    const nullOption = this.choiceList.find(e => e.value === null || e.value === 'null' || e.value === '');
                    if (nullOption) {
                        this.searchText = nullOption.label;
                    }
                }
            }
            // Highlight the currently selected option
            this.setHighlightToCurrentSelection();
            // Focus the input after opening and preserve cursor position
            setTimeout(() => {
                if (this.inputElement) {
                    this.inputElement.focus();
                    // Move cursor to end
                    this.inputElement.setSelectionRange(this.inputElement.value.length, this.inputElement.value.length);
                }
            }, 0);
        }
    }
    setHighlightToCurrentSelection() {
        if (this.filteredChoices) {
            // Handle null values properly
            if (this.value === null || this.value === undefined || this.value === '' || this.value === 'null') {
                const currentIndex = this.filteredChoices.findIndex(choice => choice.value === null || choice.value === 'null' || choice.value === '');
                this.highlightedIndex = currentIndex >= 0 ? currentIndex : -1;
            }
            else if (this.value) {
                const currentIndex = this.filteredChoices.findIndex(choice => choice.value === this.value);
                this.highlightedIndex = currentIndex >= 0 ? currentIndex : -1;
            }
            else {
                this.highlightedIndex = -1;
            }
        }
        else {
            this.highlightedIndex = -1;
        }
    }
    onInputChange(e) {
        const target = e.target;
        this.searchText = target.value;
        if (!this.isOpen) {
            this.isOpen = true;
        }
        // Only filter when typing, reset highlight when filtering
        this.highlightedIndex = -1;
        this.updateFilteredChoices();
        return true;
    }
    onInputKeyDown(e) {
        // ONLY handle special navigation keys - let everything else pass through
        const isNavKey = e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === 'Escape';
        if (!isNavKey) {
            return true;
        }
        // Handle navigation keys
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!this.isOpen) {
                this.isOpen = true;
                this.updateFilteredChoices();
            }
            else {
                // Wrap around: go to first when reaching the end
                if (this.highlightedIndex >= this.filteredChoices.length - 1) {
                    this.highlightedIndex = 0;
                }
                else {
                    this.highlightedIndex = this.highlightedIndex + 1;
                }
            }
        }
        else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (!this.isOpen) {
                this.isOpen = true;
                this.updateFilteredChoices();
            }
            else {
                // Wrap around: go to last when at first/none selected
                if (this.highlightedIndex <= 0) {
                    this.highlightedIndex = this.filteredChoices.length - 1;
                }
                else {
                    this.highlightedIndex = this.highlightedIndex - 1;
                }
            }
        }
        else if (e.key === 'Enter' && this.isOpen) {
            e.preventDefault();
            if (this.highlightedIndex >= 0 && this.filteredChoices[this.highlightedIndex]) {
                this.selectOption(this.filteredChoices[this.highlightedIndex]);
            }
            else if (this.allowCreation && this.searchText.trim()) {
                this.addNewItem();
            }
        }
        else if (e.key === 'Escape') {
            e.preventDefault();
            this.isOpen = false;
            // DON'T change searchText on escape - keep what user typed
            this.highlightedIndex = -1;
        }
    }
    selectOption(option) {
        const oldValue = this.value;
        this.value = option.value;
        this.searchText = option.label; // Show selected label
        this.isOpen = false;
        this.highlightedIndex = -1;
        // Emit change event for user-initiated selections
        // Convert null-like values for consistent handling
        const normalizedValue = (!option.value || option.value === 'null' || option.value === 'undefined') ? null : option.value;
        const normalizedOld = (!oldValue || oldValue === 'null' || oldValue === 'undefined') ? null : oldValue;
        this.$emit('change', { value: normalizedValue, oldValue: normalizedOld });
    }
    addNewItem() {
        if (!this.searchText.trim())
            return;
        const existingChoice = this.choiceList.find(c => c.label.toLowerCase() === this.searchText.toLowerCase());
        if (existingChoice) {
            this.selectOption(existingChoice);
        }
        else {
            const newItem = {
                label: this.searchText.trim(),
                value: this.searchText.trim().toLowerCase().replace(/\s+/g, '_')
            };
            this.choiceList = [...this.choiceList, newItem];
            this.selectOption(newItem);
            this.$emit('createItem', newItem);
        }
    }
    onAddButtonClick() {
        if (this.allowCreation) {
            this.addNewItem();
        }
    }
    onClearClick() {
        this.value = '';
        this.searchText = '';
        this.realValue = '';
        this.isOpen = false;
        this.highlightedIndex = -1;
        this.filteredChoices = [...this.choiceList];
        // Focus the input after clearing
        setTimeout(() => {
            if (this.inputElement) {
                this.inputElement.focus();
            }
        }, 0);
        this.$emit('change', { value: '', oldValue: this.value });
    }
    isSelected(item) {
        return item.value === this.value;
    }
    isHighlighted(item) {
        const index = this.filteredChoices.indexOf(item);
        return index === this.highlightedIndex;
    }
    // Backwards compatibility methods
    setValue() {
        return this.realValue || null;
    }
    onSelect(e) {
        // Backwards compatibility - not used in new implementation
    }
};
exports.VSelect = VSelect;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], VSelect.prototype, "choiceList", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], VSelect.prototype, "realValue", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VSelect.prototype, "creationReady", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VSelect.prototype, "isOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], VSelect.prototype, "searchText", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], VSelect.prototype, "filteredChoices", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], VSelect.prototype, "highlightedIndex", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VSelect.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VSelect.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VSelect.prototype, "name", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], VSelect.prototype, "required", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], VSelect.prototype, "allowCreation", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VSelect.prototype, "side", void 0);
exports.VSelect = VSelect = __decorate([
    (0, client_1.RWSView)('v-select', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], VSelect);
VSelect.defineComponent();
